<template>
  <div
    class="p-0 flex flex-col items-center justify-center md:grid md:grid-cols-4 md:content-center"
  >
    <div class="flex justify-center py-5 w-full px-5 md:col-span-1 md:px-10" />
    <div class="col-span-full md:col-span-3 w-full md:w-auto">
      <div class="grid grid-cols-11 md:justify-center items-center gap-x-2">
        <div
          class="col-span-2 justify-self-center"
          :class="{
            'col-start-6': isLastestEvaluationVisible,
            'col-start-8': !isLastestEvaluationVisible,
          }"
        >
          Auto<span class="hidden sm:inline">-évaluation</span>
        </div>
        <div
          v-if="isLastestEvaluationVisible"
          class="col-span-2 justify-self-center"
        >
          Dernière<span class="hidden sm:inline"> évaluation</span>
        </div>
        <div class="col-span-2 justify-self-center">
          <div v-if="visibilityValue2">
            <span class="hidden sm:inline">Nouvelle eval. </span>ref.
          </div>
        </div>
        <div
          v-if="canHideAuto"
          class="col-span-2 flex items-center space-x-1 md:space-x-3 justify-self-center sm:justify-self-start"
          :class="{
            'cursor-help': !$can('comppro_auto_eval_read', idPass),
            'cursor-pointer': $can('comppro_auto_eval_read', idPass),
            'col-start-6': isLastestEvaluationVisible,
            'col-start-8': !isLastestEvaluationVisible,
          }"
          @click.stop="
            $can('comppro_auto_eval_read', idPass) ? $emit('hideValue1') : null
          "
          :title="
            $can('comppro_auto_eval_read', idPass)
              ? null
              : 'Permission manquante'
          "
        >
          <icon
            :name="isHiddenValue1 ? 'eye-off' : 'eye'"
            class="h-3 w-4 text-pink-600"
          />
          <span class="hidden sm:inline text-sm select-none">
            {{ isHiddenValue1 ? 'Afficher' : 'Masquer' }}
          </span>
        </div>
        <div
          v-if="isLastestEvaluationVisible"
          class="col-span-2 flex items-center space-x-1 md:space-x-3 justify-self-center sm:justify-self-start cursor-pointer"
          @click.stop="$emit('hideLastestEvaluation')"
        >
          <icon
            :name="isHiddenLastEval ? 'eye-off' : 'eye'"
            class="h-3 w-4 text-pink-600"
          />
          <span class="hidden sm:inline text-sm select-none">
            {{ isHiddenLastEval ? 'Afficher' : 'Masquer' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon.vue';
export default {
  name: 'RomeEvaluationHeader',
  components: {
    Icon,
  },
  props: {
    canHideAuto: {
      type: Boolean,
      required: false,
      default: false,
    },
    idPass: {
      type: String,
      required: false,
      default: '',
    },
    idUser: {
      type: Number,
    },
    isHiddenValue1: {
      type: Boolean,
      required: false,
      default: true,
    },
    isHiddenLastEval: {
      type: Boolean,
      required: false,
      default: true,
    },
    visibilityValue1: {
      type: Boolean,
      required: false,
      default: true,
    },
    visibilityValue2: {
      type: Boolean,
      required: false,
      default: true,
    },
    isLastestEvaluationVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
